function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Instruktora-port\\u0101ls:-Students",
  transform: "translate(-998.000000, -2742.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Block-4",
  transform: "translate(264.000000, 2197.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Row-2",
  transform: "translate(24.000000, 79.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Summary",
  transform: "translate(710.000000, 72.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Map-+-Info",
  transform: "translate(0.000000, 36.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(0.000000, 358.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "viewbox",
  points: "0 0 24 0 24 24 0 24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.20711,1.79289 L13.70711,4.29289 C14.0976,4.68342 14.0976,5.31658 13.70711,5.70711 L11.20711,8.20711 L11.1129015,8.29029769 C10.7206064,8.59531923 10.1533792,8.56759 9.79289,8.20711 C9.40237,7.81658 9.40237,7.18342 9.79289,6.79289 L10.584,6 L6.5,6 C5.11929,6 4,7.11929 4,8.5 L4.00531769,8.66437548 C4.08996147,9.96846234 5.1745184,11 6.5,11 L17.5,11 C19.9853,11 22,13.0147 22,15.5 L21.9951021,15.7118372 C21.8844901,18.0987811 19.9142914,20 17.5,20 L8.87381203,20.0006627 C8.4295391,21.7255542 6.86360173,23 5,23 L4.80035957,22.9951047 C2.68396753,22.8910789 1,21.1421964 1,19 L1.0048953,18.8003596 C1.10892107,16.6839675 2.85780364,15 5,15 L5.19964043,15.0048953 C6.97503083,15.09216 8.44611853,16.3369316 8.87408289,18.0003895 L17.5,18 C18.8807,18 20,16.8807 20,15.5 L19.9946823,15.3356256 C19.9100378,14.0315469 18.825472,13 17.5,13 L6.5,13 L6.28816441,12.995102 C3.90123781,12.884489 2,10.914272 2,8.5 L2.00489799,8.28816441 C2.11551099,5.90123781 4.085728,4 6.5,4 L10.585,4 L9.79289,3.2071 C9.40237,2.81658 9.40237,2.18341 9.79289,1.79289 C10.18342,1.40237 10.81658,1.40237 11.20711,1.79289 Z M5,17 L4.85073759,17.0054857 C3.81587733,17.0818348 3,17.9456377 3,19 L3.00548573,19.1492624 C3.08183483,20.1841227 3.94563773,21 5,21 L5.14926241,20.9945143 C6.18412267,20.9181652 7,20.0543623 7,19 L6.99451427,18.8507376 C6.91816517,17.8158773 6.05436227,17 5,17 Z M19,1 L19.1996404,1.0048953 C21.3160325,1.10892107 23,2.85780364 23,5 L22.9951047,5.19964043 C22.8910789,7.31603247 21.1421964,9 19,9 L18.8003596,8.9951047 C16.6839675,8.89107893 15,7.14219636 15,5 L15.0048953,4.80035957 C15.1089211,2.68396753 16.8578036,1 19,1 Z M19,3 L18.8507376,3.00548573 C17.8158773,3.08183483 17,3.94563773 17,5 L17.0054857,5.14926241 C17.0818348,6.18412267 17.9456377,7 19,7 L19.1492624,6.99451427 C20.1841227,6.91816517 21,6.05436227 21,5 L20.9945143,4.85073759 C20.9181652,3.81587733 20.0543623,3 19,3 Z",
  id: "icon",
  fill: "#079DC1"
}))))))));

function SvgIcDistance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B1DC91D7-2FE8-41D2-A148-30AFA127EACA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDistance);
export default __webpack_public_path__ + "static/media/ic-distance.9ab74bab.svg";
export { ForwardRef as ReactComponent };